import { Building2, Home, Maximize2 } from "lucide-react";
import { FC } from "react";

import { formatEuroPrice } from "../../utils/realEstateFormatters";
import { ParcImmobilierMinimalDto } from "api/real-estate";

interface ParcCardProps {
  parc: ParcImmobilierMinimalDto;
  isSelected: boolean;
  onSelect: () => void;
}

const Stat: FC<{ icon: React.ReactNode; value: string; label: string }> = ({ icon, value, label }) => (
  <div className="flex flex-col items-center gap-0.5 grow">
    <span className="text-gray-400">{icon}</span>
    <span className="text-lg font-semibold text-gray-900">{value}</span>
    <span className="text-xs text-gray-500">{label}</span>
  </div>
);

export const ParcCard: FC<ParcCardProps> = ({ parc, isSelected, onSelect }) => {
  const count = parc.realEstatesCount;
  const totalSurface = parc.totalArea ?? 0;
  const totalRent = parc.totalRent ?? 0;

  return (
    <div
      onClick={onSelect}
      className={`relative bg-white cursor-pointer border shadow rounded-xl p-5 hover:shadow-md transition-shadow ${
        isSelected ? 'ring-2 ring-primary shadow-md' : ''
      }`}
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Building2 className="text-primary" size={20} />
        </div>
        <div className="flex flex-col min-w-0">
          <h3 className="font-medium text-gray-900 truncate">{parc.name}</h3>
          <span className="text-xs text-gray-400">{parc.reference}</span>
        </div>
      </div>

      <div className="flex items-center border-t pt-4">
        <Stat icon={<Home size={16} />} value={`${count}`} label={count > 1 ? "biens" : "bien"} />
        <div className="border-l h-10" />
        <Stat icon={<Maximize2 size={16} />} value={`${totalSurface} m²`} label="surface" />
        {totalRent > 0 && (
          <>
            <div className="border-l h-10" />
            <Stat icon={<span className="text-sm font-semibold">€</span>} value={formatEuroPrice(totalRent)} label="loyer / mois" />
          </>
        )}
      </div>
    </div>
  );
};
